import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const GamingConsole = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M15.665 16.37h-3a.333.333 0 1 1 0-.667H15v-14h-6V7.37a.333.333 0 1 1-.667 0V1.037h7.333V16.37Z" />
      <path d="M12 10.037a.334.334 0 0 1-.334-.333v-5a.333.333 0 1 1 .667 0v5a.333.333 0 0 1-.334.333ZM6 8.704a.333.333 0 0 1-.334-.333V4.704a.333.333 0 1 1 .667 0v3.667a.333.333 0 0 1-.334.333ZM7 14.37H5a.333.333 0 0 1 0-.667h2a.333.333 0 1 1 0 .667Z" />
      <path d="M1.827 16.37a1.16 1.16 0 0 1-1.161-1.168v-.014c.003-.069.01-.137.021-.205l.004-.023 1.03-4.517a1.83 1.83 0 0 1 3.192-.74h2.172a1.83 1.83 0 0 1 3.193.74v.004l1.034 4.536c.01.068.017.136.02.205v.014a1.163 1.163 0 0 1-1.89.913l-1.195-.927a.333.333 0 0 1 .408-.527l1.204.933a.496.496 0 0 0 .795-.497l-1.025-4.5a1.163 1.163 0 0 0-2.1-.374l-.096.147H4.569l-.1-.147a1.163 1.163 0 0 0-2.098.374l-1.026 4.5a.496.496 0 0 0 .795.497l.005-.005 1.2-.928a.333.333 0 0 1 .408.527l-1.197.927a1.167 1.167 0 0 1-.73.255Z" />
      <path d="M8 12.703a1.333 1.333 0 1 1 0 2.667 1.333 1.333 0 0 1 0-2.667Zm0 2a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334ZM4 12.703a1.333 1.333 0 1 1 0 2.667 1.333 1.333 0 0 1 0-2.667Zm0 2a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334Z" />
    </svg>
  );
};

GamingConsole.category = 'product-category';

GamingConsole.displayName = 'GamingConsole';
